import { getAppConfig } from "../../utils/configuration";
import { AuthStateInterface, getAuthInfo } from '../../utils/auth';
import { MessageReceived, MessageSendAction, MessageSent } from "../../models/webSockets";
import { AbstractSocketService } from "./abstractSocketService";
import { getRuntime } from "../../utils/runtime";
import { RuntimeType } from "../../models/runtime";
import MockSocketService from "./mockSocketService";

class SocketService extends AbstractSocketService {
  private authToken: string;
  private websocketUrl: string;
  private socket: WebSocket;

  constructor({ channel }: { channel: string }) {
    super();

    if (!channel) {
      return;
    }

    const authorizationInfo: AuthStateInterface = getAuthInfo();
    this.authToken = authorizationInfo?.authToken || '';
    this.messageListeners = [];
    const { websocketUrl } = getAppConfig();
    const queryString = new URLSearchParams({ channel }).toString();
    this.websocketUrl = `${websocketUrl}?${queryString}`;

    this.init();
  }

  private async init() {
    try {
      const socket = new WebSocket(this.websocketUrl, [this.authToken]);
      socket.addEventListener('open', (event: Event) => {
        console.log('WebSocket connection open', event);
      });
      socket.addEventListener("message", (event: MessageEvent) => {
        this.handleMessage(event.data);
      });
      this.socket = socket;
    } catch (err) {
      console.error('WebSocket could not conect', err);
    }
  }

  public static getInstance(channel?: string): AbstractSocketService {
    if (!AbstractSocketService.instance) {
      const runtime = getRuntime();
      const useSocketService = runtime === RuntimeType.itp;

      if (!useSocketService) {
        AbstractSocketService.instance = new MockSocketService();
        return AbstractSocketService.instance;
      }

      if (!channel) {
        throw new Error('Channel name is required for webSocket');
      }

      AbstractSocketService.instance = new SocketService({ channel });
    }

    return AbstractSocketService.instance;
  }

  public sendMessage (message: string | Blob | ArrayBufferLike | ArrayBufferView<ArrayBufferLike> | MessageSent) {
    this.socket.send(JSON.stringify(message));
  }

  public async broadcastMessage<T>(payload: MessageReceived<T>, excludeSender = true) {
    const message: MessageSent<T> = {
      action: MessageSendAction.BROADCAST,
      payload,
      excludeSender,
    };

    this.sendMessage(message);
  }

}

export default SocketService;
